/**
 * @generated SignedSource<<a1c975712e6aff2575185392dd259998>>
 * @relayHash 186c8bbb9834e8623ccdc1e2f59099c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78

import type { ConcreteRequest } from 'relay-runtime';
export type hiddenLayoutSectionWarningQuery$variables = {
  cloudId: string;
  layoutAri: string;
};
export type hiddenLayoutSectionWarningQuery$data = {
  readonly helpLayout: {
    readonly layout: {
      readonly sections?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly subsections: ReadonlyArray<{
              readonly elements: ReadonlyArray<{
                readonly __typename: string;
              } | null> | null;
            } | null> | null;
            readonly visualConfig: {
              readonly hidden: boolean | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    };
  } | null;
};
export type hiddenLayoutSectionWarningQuery = {
  response: hiddenLayoutSectionWarningQuery$data;
  variables: hiddenLayoutSectionWarningQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "layoutAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "layoutAri"
  }
],
v3 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hidden"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "hiddenLayoutSectionWarningQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v2/*: any*/),
              "kind": "LinkedField",
              "name": "layout",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "HelpLayoutSectionConnection",
                      "kind": "LinkedField",
                      "name": "sections",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "HelpLayoutSectionEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "HelpLayoutSection",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v3/*: any*/),
                                {
                                  "concreteType": "HelpLayoutSubsection",
                                  "kind": "LinkedField",
                                  "name": "subsections",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "name": "elements",
                                      "plural": true,
                                      "selections": [
                                        (v4/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "type": "HelpLayout"
                }
              ]
            },
            "action": "THROW",
            "path": "helpLayout.layout"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hiddenLayoutSectionWarningQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "layout",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpLayoutSectionConnection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpLayoutSectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "HelpLayoutSection",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "concreteType": "HelpLayoutSubsection",
                                "kind": "LinkedField",
                                "name": "subsections",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  },
                                  (v5/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpLayout"
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78",
    "metadata": {},
    "name": "hiddenLayoutSectionWarningQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f2fd5d711a9bee2d942b12cdd41c9d79";

export default node;
